/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React from 'react';
import { Table } from 'antd';
import dayjs from 'dayjs';
import fmt from 'indian-number-format';

interface Props {
  transactions?: any[];
  depositNumber?: string;
}

export default function DepositTransactionsModal({
  transactions,
  depositNumber,
}: Props): JSX.Element {
  const totals = transactions?.reduce(
    (acc: any, txn: any) => {
      acc.interestAmount += txn.interestAmount || 0;
      acc.principal += txn.principal || 0;
      acc.onlineInterest += txn.onlineInterest || 0;
      acc.offlineInterest += txn.offlineInterest || 0;
      acc.reducingInterest += txn.reducingInterest || 0;
      acc.onlinePrincipal += txn.onlinePrincipal || 0;
      acc.offlinePrincipal += txn.offlinePrincipal || 0;
      return acc;
    },
    {
      interestAmount: 0,
      principal: 0,
      onlineInterest: 0,
      offlineInterest: 0,
      reducingInterest: 0,
      onlinePrincipal: 0,
      offlinePrincipal: 0,
    }
  ) || {
    interestAmount: 0,
    principal: 0,
    onlineInterest: 0,
    offlineInterest: 0,
    reducingInterest: 0,
    onlinePrincipal: 0,
    offlinePrincipal: 0,
  };

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      key: 'sno',
      render: (_: any, record: any, index: number) => <p>{index + 1}</p>,
      width: 50,
    },
    {
      title: 'Transaction Date',
      dataIndex: 'transactionDate',
      key: 'transactionDate',
      render: (_: any, record: any) => (
        <p>{dayjs(record.transactionDate).format('DD-MM-YYYY')}</p>
      ),
    },
    {
      title: 'Interest Paid',
      dataIndex: 'interestAmount',
      key: 'interestAmount',
      render: (_: any, record: any) => {
        const hasInterest = (record.interestAmount ?? 0) > 0;
        const hasReducingInterest = (record.reducingInterest ?? 0) > 0;
        return (
          <div>
            {hasInterest ? (
              <>
                <p>
                  Online: {fmt.format(record.onlineInterest ?? 0)} | Offline: {fmt.format(record.offlineInterest ?? 0)} | Total: {fmt.format(record.interestAmount ?? 0)}
                </p>
                {hasReducingInterest && (
                  <p>
                    Reducing: {fmt.format(record.reducingInterest ?? 0)}
                  </p>
                )}
              </>
            ) : (
              <p>-</p>
            )}
          </div>
        );
      },
    },
    {
      title: 'Principal Paid',
      dataIndex: 'principal',
      key: 'principal',
      render: (_: any, record: any) => {
        const hasPrincipal = (record.principal ?? 0) > 0;
        return (
          <p>
            {hasPrincipal
              ? `Online: ${fmt.format(record.onlinePrincipal ?? 0)} | Offline: ${fmt.format(record.offlinePrincipal ?? 0)} | Total: ${fmt.format(record.principal ?? 0)}`
              : '-'}
          </p>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_: any, record: any) => (
        <p style={{ textTransform: 'capitalize' }}>
          {record.status === 'cash_settled' ? 'Cash Settled' : record.status ?? 'Pending'}
        </p>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h4>Deposit Number: {depositNumber ?? '-'}</h4>
      </div>

      <Table
        dataSource={transactions ?? []}
        columns={columns}
        pagination={false}
        rowKey={(record: any) => record._id || record.id}
        summary={() => (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={2}>
                <strong>Total</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                <div>
                  <strong>
                    Online: {fmt.format(totals.onlineInterest)} | Offline:{' '}
                    {fmt.format(totals.offlineInterest)} | Total:{' '}
                    {fmt.format(totals.interestAmount)}
                  </strong>
                  {totals.reducingInterest > 0 && (
                    <div>
                      <strong>Reducing: {fmt.format(totals.reducingInterest)}</strong>
                    </div>
                  )}
                </div>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2}>
                <strong>
                  {totals.principal > 0
                    ? `Online: ${fmt.format(totals.onlinePrincipal)} | Offline: ${fmt.format(totals.offlinePrincipal)} | Total: ${fmt.format(totals.principal)}`
                    : '-'}
                </strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3}>-</Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
      />
    </div>
  );
}
